const { render } = wp.element;
import React, { Component, useState } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { Document, Page } from 'react-pdf';
//Import Designs
import {
    Typography,
    Grid2,
    CardMedia,
    Link,
    DialogActions,
    Button,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    IconButton,
} from '@mui/material';

//Gallery
// import ReactBnbGallery from 'react-bnb-gallery';
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";

import CloseIcon from '@mui/icons-material/Close';
import { addHours } from "date-fns";
import dateFormat from 'dateformat';

const calculateVoteTimeLeft = (start_time, current_date, pause_voting_hours = 0) => {
    if (!current_date) {
        current_date = new Date();
    }
    if (start_time != null) {
        start_time = start_time.replace(/ /g, "T");
        // var dateFormat = require("dateformat");
        var start_Date = dateFormat(start_time);
        let difference = addHours(new Date(start_Date), pause_voting_hours) - current_date;
        return difference;
    } else {
        return -1;
    }
}

//Render Datas for Gallery
const getCustomImages = (custom_field, custom_value, post, get_view, allprops, currentdate) => {

    let label_test = null;
    let view_val = null;
    switch (get_view) {
        case 'grid':
            label_test = 'show_labels';
            view_val = 'grid_only';
            break;
        case 'list':
            label_test = 'show_labels';
            view_val = 'list_only';
            break;
        case 'single':
            label_test = 'show_labels_single';
            view_val = 'admin_view';
            break;
        case 'popup':
            label_test = 'pretty_view';
            view_val = 'pretty_view';
            break;
    }

    let photos = [];
    let featured_image = post.page_cont_image != null ? post.page_cont_image : post.featured_image_url;

    let tax_hide_photos = null;
    let vote_start_time = null;
    let vote_end_time = null;
    let hide_photos = 0;
    let pagin_val_prop = null;

    const shortcode = (typeof allprops.short !== "undefined") ? allprops.short.allcatoption : null;

    if (typeof allprops.short.allcatoption !== "undefined") {
        tax_hide_photos = allprops.short.allcatoption.tax_hide_photos_live;
        if (allprops?.short?.allcatoption?.votes_starttime) {
            vote_start_time = calculateVoteTimeLeft(allprops.short.allcatoption.votes_starttime, currentdate, allprops.short.allcatoption.pause_voting);
        }
        if (allprops?.short?.allcatoption?.votes_expiration) {
            vote_end_time = calculateVoteTimeLeft(allprops.short.allcatoption.votes_expiration, currentdate);
        }
        if (tax_hide_photos != 'on') {
            hide_photos = '1';
        }
        if (allprops.short.thumb == '0') {
            hide_photos = '0';
        }
        if (vote_start_time < 0) {
            hide_photos = '1';
        }
        if (tax_hide_photos === 'on') {
            if (vote_start_time == null && vote_end_time == null)
                hide_photos = '1';

            if (vote_start_time == null && vote_end_time > 0)
                hide_photos = '1';

            pagin_val_prop = (typeof allprops.post.pagin_val !== "undefined") ? allprops.post.pagin_val : null;

            if (get_view === 'single') {
                pagin_val_prop = allprops.post_single.contestant_count;
            }
            if (pagin_val_prop != null) {
                let total_posts = get_view === 'single' ? pagin_val_prop : pagin_val_prop.total_posts;
                let tax_activationcount = allprops.short.allcatoption.tax_activationcount;
                if (tax_activationcount !== null && tax_activationcount !== 0 && tax_activationcount !== undefined && tax_activationcount !== "") {
                    if (parseInt(tax_activationcount) <= parseInt(total_posts)) {
                        hide_photos = '1';
                    }
                    else {
                        hide_photos = '0';
                        if (vote_start_time == null && vote_end_time > 0)
                            hide_photos = '1';
                    }
                    if (vote_start_time == null && vote_end_time == null)
                        hide_photos = '1';
                }
            }

            if (vote_start_time < 0 && vote_end_time > 0)
                hide_photos = '1';

        }
    }

    //Check voting button
    let time_to_vote = null;
    let timer = null;
    if (shortcode != null) {
        if (shortcode.votes_starttime != null && shortcode.votes_starttime != "") {
            timer = calculateVoteTimeLeft(shortcode.votes_starttime, shortcode.pause_voting);
            if (timer > 0) {
                time_to_vote = "not_started";
            }
        }
        if (shortcode.votes_expiration != null && shortcode.votes_expiration != "") {
            timer = calculateVoteTimeLeft(shortcode.votes_expiration);
            if (timer < 0) {
                time_to_vote = "ended";
                hide_photos = '1';
            }
        }
    }
    //override for all contestant shortcode
    if (allprops.all_contest == 1) {
        hide_photos = '1';
        popup_enabled = 'on';
    }
    //Shortcode attribute will override all conditions
    if (allprops.short.thumb == '1') {
        hide_photos = '1';
    }

    if (featured_image && hide_photos != 0) {
        let single_photos = {
            url: featured_image,
            alt: post.post_title,
            thumbnail: featured_image,
            system_name: "featured_image"
        }
        photos.push(single_photos);
    }

    custom_field.map(function (field, index) {
        if (field.system_name.includes("contestant") != true && (custom_value[field.system_name] != null && custom_value[field.system_name] != "")) {
            if (field.question_type == 'FILE') {
                if (field[label_test] == 'Y' || field[view_val] == 'Y') {
                    let single_photos = {
                        url: custom_value[field.system_name],
                        alt: post.post_title,
                        thumbnail: custom_value[field.system_name],
                        system_name: field.system_name
                    }
                    photos.push(single_photos);
                }
            }
        }
    })

    return photos;
}


const gethedershow = (custom_field, custom_value, label_test, view_val) => {
    let return_val = false;
    // console.log(custom_field);
    custom_field.map((item, index) => {
        if (item.system_name.includes("contestant") != true && (item[label_test] == 'Y' || item[view_val] == 'Y') && (custom_value[item.system_name] != null && custom_value[item.system_name] != "")) {
            return_val = true;
            return return_val;
        }
    })
    return return_val;

}

class ContestantCustom extends Component {
    constructor(props) {
        super(props);
        this.state = { galleryOpened: false, photoindex: -1, numPages: null, pageNumber: 1, pdf_popup: 0, pdf_url: null, pdf_question: null };
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    }

    getformatteddate(date_val) {
        if (date_val != null) {
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(date_val);
            return start_Date;
        }
    }

    handleimagepopup = (photoind, photos) => {
        let obj = photos.find((o, i) => {
            if (o.system_name === photoind) {
                this.setState({ photoindex: i });
                return i; // stop searching
            }
        });
        this.setState({ galleryOpened: true });
    }

    validURL(string) {
        if (string != null && (typeof string !== 'object')) {
            var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
            if (res !== null) {
                return string;
            } else
                return false;
        }
        return false;
    }

    isValidHTML(html) {
        let isHTML = /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(html);
        return isHTML;
    }

    toggleGallery = () => {
        this.setState({ galleryOpened: false });
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages: numPages });
    }

    wpvcpdf_click = (url, pdf_ques) => {
        this.setState({ pdf_popup: 1, pdf_url: url, pdf_question: pdf_ques });
    }
    handleClose = (event) => {
        this.setState({ pdf_popup: 0 });
    }

    changePage = (offset) => {
        this.setState(prevState => ({
            pageNumber: prevState.pageNumber + offset
        }));
    }

    previousPage = () => {
        this.changePage(-1);
    }

    nextPage = () => {
        this.changePage(1);
    }

    render() {
        const { t } = this.props;
        const custom = this.props.custom_field;
        const get_view = this.props.view;

        let label_test = null;
        let view_val = null;
        let grid_width = 6;
        switch (get_view) {
            case 'grid':
                label_test = 'show_labels';
                view_val = 'grid_only';
                grid_width = 6;
                break;
            case 'list':
                label_test = 'show_labels';
                view_val = 'list_only';
                grid_width = 2;
                break;
            case 'single':
                label_test = 'show_labels_single';
                view_val = 'admin_view';
                grid_width = 1;
                break;
            case 'popup':
                label_test = 'pretty_view';
                view_val = 'pretty_view';
                grid_width = 6;
                break;
        }

        if (custom) {
            const custom_value = this.props.singlepost.custom_fields_value;
            const photos = getCustomImages(custom, custom_value, this.props.singlepost, get_view, this.props, this.props.currentdate);
            const show_header = gethedershow(custom, custom_value, label_test, view_val);

            return (
                (<Grid2 container className="wpvc_custom_fields_view">
                    <Grid2 size={12}>
                        {(this.props.header == 1) && (show_header == 1) &&
                            <Typography variant="h5" className="wpvc_grid_header" >
                                {t("additional_infor")}
                            </Typography>
                        }
                    </Grid2>
                    {custom.map((item, index) => (
                        item.system_name.includes("contestant") != true && (item[label_test] == 'Y' || item[view_val] == 'Y') && (custom_value[item.system_name] != null && custom_value[item.system_name] != "") &&

                        <Grid2 key={index} container justifyContent="flex-start"
                            direction="row"
                            alignItems="flex-start"
                            className="wpvc_custom_fields_contain"
                            size={(item.question_type == 'FILE') ? grid_width : 12}>
                            {item.question_type == 'TEXT' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <Typography>
                                            <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            {(item[view_val] == 'Y' && !this.validURL(custom_value[item.system_name])) &&
                                                custom_value[item.system_name]
                                            }
                                            {(item[view_val] == 'Y' && this.validURL(custom_value[item.system_name]) && !this.isValidHTML(custom_value[item.system_name])) &&
                                                <Link
                                                    href={custom_value[item.system_name].match(/(http(s)?:\/\/.)/g) == null ? "https://" + custom_value[item.system_name] : custom_value[item.system_name]}
                                                    target="_blank"
                                                    className="wpvc_link_custom_value"
                                                >
                                                    {
                                                        custom_value[item.system_name]
                                                    }
                                                </Link>
                                            }
                                            {(item[view_val] == 'Y' && this.validURL(custom_value[item.system_name]) && this.isValidHTML(custom_value[item.system_name])) &&
                                                <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: custom_value[item.system_name] }}></div>
                                            }
                                        </Typography>
                                    }
                                </Grid2>
                            }
                            {item.question_type == 'TEXTAREA' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <Typography>
                                            <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            {(item[view_val] == 'Y') ? custom_value[item.system_name] : ''}
                                        </Typography>
                                    }
                                </Grid2>
                            }
                            {item.question_type == 'SINGLE' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <Typography>
                                            <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            {(item[view_val] == 'Y') ? custom_value[item.system_name] : ''}
                                        </Typography>
                                    }
                                </Grid2>
                            }
                            {item.question_type == 'MULTIPLE' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <Typography>
                                            <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            {(item[view_val] == 'Y') ? custom_value[item.system_name] : ''}
                                        </Typography>
                                    }
                                </Grid2>
                            }
                            {item.question_type == 'DROPDOWN' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <Typography>
                                            <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            {(item[view_val] == 'Y') ? custom_value[item.system_name] : ''}
                                        </Typography>
                                    }
                                </Grid2>
                            }

                            {item.question_type == 'DATE' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <Typography>
                                            <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            {(item[view_val] == 'Y') ? this.getformatteddate(custom_value[item.system_name]) : ''}
                                        </Typography>
                                    }
                                </Grid2>
                            }
                            {item.question_type == 'FILE' &&
                                <Grid2 className="wpvc_custom_field_label" size={12}>
                                    {(item[label_test] == 'Y' || item[view_val] == 'Y') &&
                                        <div className="wpvc_custom_field_files">
                                            <Typography>
                                                <span>{(item[label_test] == 'Y') ? item.question + ' : ' : ''}</span>
                                            </Typography>

                                            {custom_value[item.system_name] != '' && custom_value[item.system_name].match(/\.(jpg|jpeg|png|gif)$/) &&
                                                <Link
                                                    href={undefined}
                                                    onClick={() => this.handleimagepopup(item.system_name, photos)}
                                                    className="wpvc_modal_image_custom"
                                                >
                                                    <CardMedia
                                                        className={"wpvc_modal_custom_image wpvc_modal_image" + this.props.singlepost.id}
                                                        image={custom_value[item.system_name]}
                                                        title={this.props.singlepost.post_title}
                                                    />
                                                </Link>
                                            }
                                            {custom_value[item.system_name] != '' && custom_value[item.system_name].match(/\.(pdf)$/) &&
                                                <Document
                                                    className="wpvc_pdf_renderer"
                                                    file={custom_value[item.system_name]}
                                                    onLoadSuccess={this.onDocumentLoadSuccess}
                                                    onClick={() => this.wpvcpdf_click(custom_value[item.system_name], item.question)}
                                                >
                                                    <Page pageNumber={1} width={100} />
                                                </Document>
                                            }
                                            {custom_value[item.system_name] != '' && !custom_value[item.system_name].match(/\.(jpg|jpeg|png|gif|pdf)$/) &&
                                                <Link
                                                    href={custom_value[item.system_name]}
                                                    target="_blank"
                                                    className="wpvc_modal_file_custom"
                                                >
                                                    {custom_value[item.system_name].substring(custom_value[item.system_name].lastIndexOf('/') + 1)}
                                                </Link>
                                            }
                                        </div>
                                    }
                                </Grid2>
                            }
                        </Grid2>

                    ))
                    }

                    {this.state.galleryOpened ?
                        <Lightbox
                            images={photos}
                            startIndex={this.state.photoindex}
                            onClose={() => this.toggleGallery()}
                            allowZoom={false}
                            allowRotate={false}
                            doubleClickZoom={0}
                        />
                        : null
                    }

                    {this.state.pdf_popup == 1 &&
                        <Dialog maxWidth="xl" onClose={this.handleClose} open={true}>
                            <MuiDialogTitle component="div" className="wpvc_submission_popup_title" onClose={this.handleClose}>
                                <Typography variant="h6">{this.state.pdf_question}</Typography>
                                <IconButton aria-label="close" onClick={this.handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </MuiDialogTitle>

                            <MuiDialogContent dividers className="wpvc_pdf_popup_content" >
                                <Document
                                    className="wpvc_pdf_renderer_popup"
                                    file={this.state.pdf_url}
                                    onLoadSuccess={this.onDocumentLoadSuccess}
                                >
                                    <Page pageNumber={this.state.pageNumber} renderMode="svg" width={1000} />
                                </Document>
                            </MuiDialogContent>

                            <DialogActions>
                                <Typography variant="h6">Page {this.state.pageNumber || (this.state.numPages ? 1 : "--")} of {this.state.numPages || "--"}</Typography>
                                <Button onClick={this.previousPage} color="primary" disabled={this.state.pageNumber <= 1}>Previous</Button>
                                <Button onClick={this.nextPage} color="primary" disabled={this.state.pageNumber >= this.state.numPages}>Next</Button>

                                <Button onClick={this.handleClose} color="primary" autoFocus>
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    }
                </Grid2>)
            );
        } else {
            return '';
        }
    }
}

export default connect()(withTranslation("translations")(ContestantCustom));
